export const couponReportActionTypes = {
  COUPON_REPORT_SET_PAGE: 'COUPON_REPORT_SET_PAGE',
  COUPON_REPORT_SET_INIT: 'COUPON_REPORT_SET_INIT',
};